import Index from "../../../item/form/edit/Index";
import { Offcanvas } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import {
    setStatusUpdate,
    selectUnitData,
    updateItemDataAsync,
    selectStatusData,
    selectSearchData,
} from "../../../../redux/reducer/item/itemSlice";
import { selectUserData } from "../../../../redux/reducer/user/userSlice";
import { useState } from "react";

//-------------------------------------------------------------------------------
export default function ItemEditNav({ show, onHide }: { show: boolean; onHide: any }) {
    //fooks
    const [files, setFiles] = useState([]);

    //redux
    const dispatch = useAppDispatch();
    const item = useAppSelector(selectUnitData);
    const { statusUpdate } = useAppSelector(selectStatusData);
    const searchData = useAppSelector(selectSearchData);
    const { user, access_token } = useAppSelector(selectUserData);

    //view
    return (
        <>
            <Offcanvas
                show={show}
                onHide={onHide}
                placement="end"
                scroll={false}
                backdrop={true}
                onExited={() => {
                    dispatch(setStatusUpdate("init"));
                }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Index
                        item={item}
                        callback={(valueData: any) => {
                            //update server images
                            const values = { ...valueData, image: item.image };
                            //update location
                            const search = { ...searchData, id_location: user.id_location };
                            //update
                            dispatch(
                                updateItemDataAsync({
                                    data: { values, search, files },
                                    access_token,
                                })
                            );
                        }}
                        disabled={statusUpdate === "success"}
                        files={files}
                        setFiles={setFiles}
                    />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}
